import React, {useMemo, useState} from 'react'
import WizImage from '../../../components/image/WizImage'
import Text from '../../../components/text/Text'
import SidebarItem from './SidebarItem'
import useNavigation from '../../../hooks/useNavigation'
import WizButton from '../../../components/button/WizButton'
import useQueryGetMe from '../../../hooks/api/user/useQueryGetMe'
import useQueryGetUserProfile from '../../../hooks/api/user/useQueryGetUserProfile'

interface IProps {
    className?: string
    isLogin: boolean
    setIsLogin?: (e: boolean) => void
}

type TypeList =
    | 'main'
    | 'leaderboard'
    | 'post'
    | 'advertisement'
    | 'copytrading'
    | 'cashback'
    | 'analysis'
    | 'other'
    | 'backend'
    | 'other'

const Sidebar: React.FC<IProps> = ({className, isLogin, setIsLogin}) => {
    const [dimmed, setDimmed] = useState(false)

    const {goMain, goLogin} = useNavigation()
    const {data: me} = useQueryGetMe(isLogin)
    const {data: profile} = useQueryGetUserProfile(me?.id, !!me?.id)

    const mainMenuList = useMemo(() => {
        return [
            {name: 'User', tag: 'user', path: ['/', '/user']},

            {name: 'API', tag: 'api', path: ['/api']},
            {name: 'Key Probe', tag: 'key_probe', path: ['/api/probe']},
            {name: 'Pro', tag: 'pro', path: ['/pro', '/pro/detail', '/pro/history']},
        ]
    }, [])

    const eventMenu = useMemo(() => {
        return [
            {
                name: 'Promotion',
                tag: 'promotion',
                path: ['/promotion', '/promotion/create', '/promotion/detail'],
            },
            // {
            //     name: 'Promotion Event',
            //     tag: 'promotion_event',
            //     path: ['/promotion/event'],
            // },
            // {name: 'Event', tag: 'event', path: ['/event', '/event/create', '/event/detail']},

            // {
            //     name: 'Leaderboard Banner',
            //     tag: 'banner',
            //     path: ['/banner', '/banner/create', '/banner/detail'],
            // },
            // {
            //     name: 'Bottom Sheet',
            //     tag: 'bottomSheet',
            //     path: ['/campaign', '/campaign/create', '/campaign/detail'],
            // },
        ]
    }, [])

    const leagueMenu = useMemo(() => {
        return [{name: 'League', tag: 'league', path: ['/league', '/league/create', '/league/detail']}]
    }, [])

    const volumeLeagueMenu = useMemo(() => {
        return [
            {
                name: 'Volume League',
                tag: 'volume_league',
                path: ['/volume_league'],
            },
        ]
    }, [])

    const feedMenu = useMemo(() => {
        return [
            {
                name: 'Feed',
                tag: 'feed',
                path: ['/feed'],
            },
        ]
    }, [])

    const badgeMenu = useMemo(() => {
        return [
            {name: 'Badge', tag: 'badge', path: ['/badge', '/badge/create', '/badge/detail']},
            {name: 'User Badge', tag: 'badge', path: ['/badge/user']},
        ]
    }, [])

    const advertisementMenu = useMemo(() => {
        return [
            {name: 'Floating', tag: 'floating', path: ['/floating', '/floating/create', '/floating/detail']},
            // {
            //     name: 'Leaderboard Ads',
            //     tag: 'ads',
            //     path: ['/advertisement', '/advertisement/create', '/advertisement/detail'],
            // },
        ]
    }, [])

    const postMenuList = useMemo(() => {
        return [
            {name: 'Announce', tag: 'announce', path: ['/announce', '/announce/detail', '/announce/create']},
            {name: 'Timeline', tag: 'timeline', path: ['/post', '/post/detail', '/post/create']},
            {name: 'Comment', tag: 'comment', path: ['/comment', '/comment/detail']},
            {name: 'Pinned Post', tag: 'pinnedPost', path: ['/recommend']},
            {name: 'News', tag: 'news', path: ['/news']},
            {name: 'Report', tag: 'report', path: ['/report']},
        ]
    }, [])

    const copyTradingMenu = useMemo(() => {
        return [
            {name: 'Leader', tag: 'leader', path: ['/leader', '/leader/detail']},
            {
                name: 'Copier',
                tag: 'copier',
                path: ['/copier', '/copier/detail'],
            },
            {name: 'Invoices', tag: 'invoices', path: ['/invoices', '/invoices/detail']},
            {name: 'Fee', tag: 'fee', path: ['/copytrading_fee']},
        ]
    }, [])

    // const cashbackMenu = useMemo(() => {
    //     return [
    //         {name: 'Referral', tag: 'referral', path: ['/referral', '/referral/detail']},
    //         {name: 'Withdraw', tag: 'withdraw', path: ['/withdraw_cashback']},
    //         {name: 'Reward History', tag: 'reward_history', path: ['/reward_history']},
    //     ]
    // }, [])

    const analysisMenu = useMemo(() => {
        return [
            {name: 'Active API', tag: 'Active API', path: ['/analysis/activekey']},
            {
                name: 'Copybot',
                tag: 'copybot',
                path: ['/analysis/copy'],
            },
            {
                name: 'Register User',
                tag: 'register_user',
                path: ['/analysis/register'],
            },
            {
                name: 'Intelligence-v2',
                tag: 'intelligence-v2',
                path: ['/analysis/intelligence'],
            },
        ]
    }, [])

    const withdrawMenu = useMemo(() => {
        return [
            {
                name: 'Withdraw',
                tag: 'withdraw',
                path: ['/withdraw', '/withdraw/detail'],
            },
            {name: 'Pay to See', tag: 'paytosee', path: ['/pts']},
        ]
    }, [])

    const otherMenu = useMemo(() => {
        return [
            {name: 'Point', tag: 'point', path: ['/point']},
            {name: 'Upbit NFT', tag: 'upbit nft', path: ['/nft']},
            {name: 'Abnormal', tag: 'abnormal', path: ['/abnormal']},

            {
                name: 'Retract',
                tag: 'retract',
                path: ['/retract'],
            },
        ]
    }, [])

    const backEndMenu = useMemo(() => {
        return [
            {name: 'Logs', tag: 'logs', path: ['/logs']},
            {name: 'Devs', tag: 'dev', path: ['/dev']},
        ]
    }, [])

    const logoutFunc = () => {
        localStorage.removeItem('wiz-admin-userId')
        localStorage.removeItem('wiz-admin-userToken')
        setIsLogin(false)
        goLogin()
    }

    const isCheckOfficial = useMemo(() => profile?.is_official === true, [profile])

    const officialStyle = useMemo(() => {
        if (isCheckOfficial) {
            return 'text-primary bg-tag_green_light'
        }
        return 'text-font_red bg-tag_red_light'
    }, [isCheckOfficial])

    return isLogin ? (
        <>
            <div className={'hidden lg:block fixed top-0 left-0 w-full bg-white py-[20px] shadow-hover z-[999]'}>
                <div onClick={() => setDimmed(true)} className={'space-y-[3px] cursor-pointer relative left-[20px]'}>
                    <div className={'w-[24px] h-[3px] bg-font01'} />
                    <div className={'w-[24px] h-[3px] bg-font01'} />
                    <div className={'w-[24px] h-[3px] bg-font01'} />
                </div>
            </div>
            <div
                onClick={() => setDimmed(false)}
                className={`hidden ${
                    dimmed ? 'lg:block lg:opacity-[0.4] delay-500' : 'lg:opacity-0'
                } lg:fixed lg:w-full lg:h-full lg:top-0 lg:left-0 lg:bg-font01 lg:cursor-pointer z-[5] duration-1000`}
            />
            <div
                onClick={() => setDimmed(false)}
                className={`bg-white min-w-[240px] border-r border-r-line01 py-[60px] min-h-screen lg:fixed lg:z-[5] lg:left-0 lg:max-h-[100%] lg:overflow-y-auto duration-500 ${
                    dimmed ? 'lg:left-0' : 'lg:left-[-270px] '
                } lg:z-[9999]  lg:max-w-[50%] ${className}`}>
                <div className="w-[100%] mx-auto">
                    <div
                        onClick={() => {
                            goMain()
                        }}
                        className={'flex space-x-[10px] items-center justify-center cursor-pointer'}>
                        <WizImage src={'/lot/logo.png'} className={'w-[36px]'} />
                        <Text className={'text-h3'}>Admin LoT</Text>
                    </div>

                    {/* Login Account */}
                    <div className="px-3 mt-3">
                        <div className="border rounded-[5px] p-2 border-line01">
                            <Text className="text-font03 text-body3">Login Account</Text>
                            <Text className={'text-ti2 text-font01 mt-1'}>{me?.name}</Text>
                            <Text className={'text-ti2 text-font02 '}>{me?.email}</Text>
                            <div className="mt-1 flex items-center gap-x-1">
                                <Text className={`${officialStyle} text-ti3 py-[2px] px-1 rounded-[3px]`}>
                                    {isCheckOfficial ? '공식 계정' : '공식 계정 ❌'}
                                </Text>
                            </div>
                        </div>
                    </div>

                    {/* User Info */}
                    <div className={'mt-[40px] border-b pb-[10px] px-[25px]'}>
                        <div className={`space-y-[10px] transition-all duration-300 ease-in-out overflow-hidden`}>
                            <Text className={'text-ti1 text-font01'}>Dashboard</Text>
                            {mainMenuList.map((item, idx) => (
                                <SidebarItem key={item?.name} item={item} />
                            ))}
                        </div>
                    </div>

                    {/* Event */}
                    <div className={'mt-[20px] border-b pb-[10px] px-[25px]'}>
                        <div className={`space-y-[10px] transition-all duration-300 ease-in-out overflow-hidden`}>
                            <Text className={'text-ti1 text-font01'}>Promotion</Text>
                            {eventMenu.map((item, idx) => (
                                <SidebarItem item={item} key={idx} />
                            ))}
                        </div>
                    </div>

                    {/* League */}
                    <div className={'mt-[20px] border-b pb-[10px] px-[25px]'}>
                        <div className={`space-y-[10px] transition-all duration-300 ease-in-out overflow-hidden`}>
                            <Text className={'text-ti1 text-font01'}>League</Text>
                            {leagueMenu.map((item, idx) => (
                                <SidebarItem item={item} key={idx} />
                            ))}
                        </div>
                    </div>

                    {/* Volume League */}
                    <div className={'mt-[20px] border-b pb-[10px] px-[25px]'}>
                        <div className={`space-y-[10px] transition-all duration-300 ease-in-out overflow-hidden`}>
                            <Text className={'text-ti1 text-font01'}>Volume League</Text>
                            {volumeLeagueMenu.map((item, idx) => (
                                <SidebarItem item={item} key={idx} />
                            ))}
                        </div>
                    </div>

                    {/* Feed */}
                    <div className={'mt-[20px] border-b pb-[10px] px-[25px]'}>
                        <div className={`space-y-[10px] transition-all duration-300 ease-in-out overflow-hidden`}>
                            <Text className={'text-ti1 text-font01'}>Feed</Text>
                            {feedMenu.map((item, idx) => (
                                <SidebarItem item={item} key={idx} />
                            ))}
                        </div>
                    </div>

                    {/* Badge */}
                    <div className={'mt-[20px] border-b pb-[10px] px-[25px]'}>
                        <div className={`space-y-[10px] transition-all duration-300 ease-in-out overflow-hidden`}>
                            <Text className={'text-ti1 text-font01'}>Badge</Text>
                            {badgeMenu.map((item, idx) => (
                                <SidebarItem item={item} key={idx} />
                            ))}
                        </div>
                    </div>

                    {/* Post */}

                    <div className={'mt-[20px] border-b pb-[10px] px-[25px]'}>
                        <div className={`space-y-[10px] transition-all duration-300 ease-in-out overflow-hidden`}>
                            <Text className={'text-ti1 text-font01'}>Posting</Text>
                            {postMenuList.map((item, idx) => (
                                <SidebarItem item={item} key={idx} />
                            ))}
                        </div>
                    </div>

                    {/* Ads */}
                    {/* <div className={'mt-[20px] border-b pb-[10px] px-[25px]'}>
                        <div className={`space-y-[10px] transition-all duration-300 ease-in-out overflow-hidden `}>
                            <Text className={'text-ti1 text-font01'}>Advertisement</Text>
                            {advertisementMenu.map((item, idx) => (
                                <SidebarItem item={item} key={idx} />
                            ))}
                        </div>
                    </div> */}

                    {/* Copy Trading */}
                    <div className={'mt-[20px] border-b pb-[10px] px-[25px]'}>
                        <div className={`space-y-[10px] transition-all duration-300 ease-in-out overflow-hidden`}>
                            <Text className={'text-ti1 text-font01'}>Copy Trading</Text>
                            {copyTradingMenu.map((item, idx) => (
                                <SidebarItem item={item} key={idx} />
                            ))}
                        </div>
                    </div>

                    {/* Withdraw */}
                    <div className={'mt-[20px] border-b pb-[10px] px-[25px]'}>
                        <div className={`space-y-[10px] transition-all duration-300 ease-in-out overflow-hidden`}>
                            <Text className={'text-ti1 text-font01'}>Withdraw</Text>
                            {withdrawMenu.map((item, idx) => (
                                <SidebarItem item={item} key={idx} />
                            ))}
                        </div>
                    </div>

                    {/* <div className={'mt-[20px] border-b pb-[10px] px-[25px]'}>
                        <div className={`space-y-[10px] transition-all duration-300 ease-in-out overflow-hidden`}>
                            <Text className={'text-ti1 text-font01'}>Cashback</Text>
                            {cashbackMenu.map((item, idx) => (
                                <SidebarItem item={item} key={idx} />
                            ))}
                        </div>
                    </div> */}

                    {/* Analysis */}
                    <div className={'mt-[20px] border-b pb-[10px] px-[25px]'}>
                        <div className={`space-y-[10px] transition-all duration-300 ease-in-out overflow-hidden`}>
                            <Text className={'text-ti1 text-font01'}>Analysis</Text>
                            {analysisMenu.map((item, idx) => (
                                <SidebarItem item={item} key={idx} />
                            ))}
                        </div>
                    </div>

                    {/* Backend */}
                    <div className={'mt-[20px] border-b pb-[10px] px-[25px]'}>
                        <div className={`space-y-[10px] transition-all duration-300 ease-in-out overflow-hidden`}>
                            <Text className={'text-ti1 text-font01'}>Backend</Text>
                            {backEndMenu.map((item, idx) => (
                                <SidebarItem item={item} key={idx} />
                            ))}
                        </div>
                    </div>

                    {/* Other */}
                    <div className={'mt-[20px] border-b pb-[10px] px-[25px]'}>
                        <div className={`space-y-[10px] transition-all duration-300 ease-in-out overflow-hidden`}>
                            <Text className={'text-ti1 text-font01'}>Other</Text>
                            {otherMenu.map((item, idx) => (
                                <SidebarItem item={item} key={idx} />
                            ))}
                        </div>
                    </div>

                    <div className={'mt-[30px] px-[15px]'}>
                        <WizButton onClick={() => logoutFunc()} text={'Logout'} className={'w-full'} />
                    </div>
                </div>
            </div>
        </>
    ) : (
        <></>
    )
}

export default Sidebar
